import requestAxios from "@/helpers/request_axios";
import * as MutationsType from "./mutationsType";

export default {
  async getSubscriptionConfig({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/subscription",
        method: "GET",
      });

      commit(MutationsType.SET_SUBSCRIPTION, response.data.data);
    } catch (error) {
      console.error("getSubscription: ", error);
      throw error.response.data;
    }
  },
  // eslint-disable-next-line
  async getSubscriptionPaymentAdmin({}) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/subscription/payments",
        method: "GET",
      });

      return response.data.data;
    } catch (error) {
      console.error("getSubscriptionPaymentAdmin: ", error);
      throw error.response.data;
    }
  },
  async updateSubscription({ commit }, { stripe_price_id }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/subscription",
        method: "PATCH",
        data: { stripe_price_id },
      });

      commit(MutationsType.SET_SUBSCRIPTION, response.data.data);
    } catch (error) {
      console.error("updateSubscription: ", error);
      throw error.response.data;
    }
  },
  async cancelSubscription({ commit }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/subscription",
        method: "DELETE",
      });

      commit(MutationsType.SET_SUBSCRIPTION, response.data.data);
    } catch (error) {
      console.error("cancelSubscription: ", error);
      throw error.response.data;
    }
  },
  resetModuleSubscription({ commit }) {
    commit(MutationsType.SET_SUBSCRIPTION, null);
  },
};
